export const sourceConstants = {

    ACTION_SAVE: 'SOURCE_ACTION_SAVE',
    ACTION_UPDATE_PASSWORD: 'SOURCE_ACTION_UPDATE_PASSWORD',

    KICK_REQUEST: 'SOURCE_KICK_REQUEST',
    KICK_SUCCESS: 'SOURCE_KICK_SUCCESS',
    KICK_FAILURE: 'SOURCE_KICK_FAILURE',

    GETALL_REQUEST: 'SOURCE_GETALL_REQUEST',
    GETALL_SUCCESS: 'SOURCE_GETALL_SUCCESS',
    GETALL_FAILURE: 'SOURCE_GETALL_FAILURE',

    GETONE_REQUEST: 'SOURCE_GETONE_REQUEST',
    GETONE_SUCCESS: 'SOURCE_GETONE_SUCCESS',
    GETONE_FAILURE: 'SOURCE_GETONE_FAILURE',

    DELETE_REQUEST: 'SOURCE_DELETE_REQUEST',
    DELETE_SUCCESS: 'SOURCE_DELETE_SUCCESS',
    DELETE_FAILURE: 'SOURCE_DELETE_FAILURE',


};
